import { useEffect } from 'react'
import useTimeout from '@/src/hooks/useTimeout'

export default function useWindowScroll(callback: (y: number) => void, delay = 10) {
  const timedCallback = useTimeout({ callback: () => callback(window.scrollY), delay })

  useEffect(() => {
    const handleScroll = () => {
      timedCallback?.wait()
    }
    window.addEventListener('scroll', handleScroll)
    return () => {
      window.removeEventListener('scroll', handleScroll)
    }
  }, [callback, timedCallback])
}
